var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('span',{class:{
        // completed: task.status.id === 1,
        // canceled: task.status.id === 1,
      },attrs:{"title":_vm.type}},[_vm._v(_vm._s(_vm._f("truncate")(_vm.type,8)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }